import { AnnouncementStatus } from '@zennolab_platform/data-access-notification-service-api';
import { useTheme } from '@zennolab_platform/webui-kit/dist/ui';
import { ConfigProvider } from '@zennolab_platform/webui-kit/dist/ui/antdComponents';

import { useAnnouncementLabels } from '../../hooks/useAnnouncementLabels';
import { KitTag } from './styled';

/** Kit StatusTag preset per status; draft and expired stay on the kit default (neutral). The kit themes only
 * success, error and default, so `processing` is themed blue locally in `StatusTag`. */
const STATUS_PRESETS: Partial<Record<AnnouncementStatus, 'success' | 'error' | 'processing'>> = {
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_SCHEDULED]: 'processing',
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_PUBLISHED]: 'success',
  [AnnouncementStatus.ANNOUNCEMENT_STATUS_WITHDRAWN]: 'error',
};

/** The announcement status as the kit StatusTag of PxM and PfM. */
export function StatusTag({ status }: { status: AnnouncementStatus }) {
  const { statusLabel } = useAnnouncementLabels();
  const { color } = useTheme();
  const preset = STATUS_PRESETS[status];
  const tag = <KitTag color={preset}>{statusLabel(status)}</KitTag>;
  if (preset !== 'processing') return tag;
  // antd 6 draws an outlined `processing` tag from the Info tokens; the kit's own provider inside keeps them.
  return (
    <ConfigProvider
      theme={{
        components: { Tag: { colorInfo: color.Blue100, colorInfoBg: color.BlueS10, colorInfoBorder: color.BlueS50 } },
      }}
    >
      {tag}
    </ConfigProvider>
  );
}
